import { FormattedMessage, useIntl } from 'react-intl';
import { PRIVACY_POLICY_URL } from './constants';
import { Controller, useFormContext } from 'react-hook-form';
import { Asterisk, StyledLink, TextWrapper } from './styles';
import { verifyLanguage } from '../../helpers/multilang.helper';
import { WowBlock, WowColorizeText, WowDisplayFlex } from '../WowBasicElements';
import Space from '../Space';
import { WowCheckbox } from '../../components/wow-checkbox';
import { newRed } from '../../config/colors';
import { useMemo } from 'react';

const PrivacyAgree = ({
  fontSize,
  includeTopSpace = true,
  includeError = true,
  url,
}) => {
  const intl = useIntl();
  const { control, formState } = useFormContext();
  const { errors } = formState;

  const privacyPolicy = useMemo(() => {
    const language = verifyLanguage(
      navigator.language || navigator.userLanguage
    );
    const href = url || (PRIVACY_POLICY_URL[language] ?? PRIVACY_POLICY_URL.en);
    return (
      <StyledLink href={href} target="_blank" rel="noopener noreferrer">
        {intl.formatMessage({ id: 'privacy_policy' })}
      </StyledLink>
    );
  }, [intl, url]);

  return (
    <WowBlock>
      {includeTopSpace && <Space height="40" />}
      <WowDisplayFlex align="flex-start" position="relative">
        <Controller
          control={control}
          name="consent_signed"
          render={({ field }) => {
            return (
              <WowCheckbox
                {...field}
                checked={field.value}
                size={20}
                borderRadius={3}
              />
            );
          }}
        />
        <Space width="10" />
        <TextWrapper size={fontSize}>
          <FormattedMessage
            id="confirmation_privacy_policy"
            values={{ privacyPolicy }}
          />
          <Asterisk>*</Asterisk>
        </TextWrapper>
      </WowDisplayFlex>
      {errors?.consent_signed && includeError ? (
        <WowColorizeText color={newRed} size="12" data-testid="inputError">
          <FormattedMessage id={errors?.consent_signed?.message} />
        </WowColorizeText>
      ) : null}
    </WowBlock>
  );
};

export default PrivacyAgree;
